import React from 'react';

const fmt = (n) => `$${(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Both / Spot (trips) / Contract (blocks) switch with the gross total of each, for the import preview. */
export const TripKindFilter = ({ value, onChange, totals }) => {
  const opts = [
    { v: 'both', label: 'Both', total: totals.trip + totals.block },
    { v: 'trip', label: 'Spot (T-)', total: totals.trip },
    { v: 'block', label: 'Contract (B-)', total: totals.block },
  ];
  return (
    <div className="grid grid-cols-3 gap-1 rounded-xl bg-slate-100 dark:bg-slate-800 p-1" role="tablist" data-testid="trip-kind-filter">
      {opts.map((o) => (
        <button
          key={o.v}
          type="button"
          role="tab"
          aria-selected={value === o.v}
          onClick={() => onChange(o.v)}
          className={`rounded-lg px-2 py-1.5 text-left transition-colors ${value === o.v ? 'bg-white dark:bg-slate-900 shadow-sm text-blue-700 dark:text-blue-300' : 'text-slate-600 dark:text-slate-300 hover:bg-white/60 dark:hover:bg-slate-900/50'}`}
          data-testid={`trip-kind-${o.v}`}
        >
          <span className="block text-[11px] font-semibold uppercase">{o.label}</span>
          <span className="block font-mono text-sm font-bold truncate" data-testid={`trip-kind-total-${o.v}`}>{fmt(o.total)}</span>
        </button>
      ))}
    </div>
  );
};

export const PaidBadge = ({ b }) => {
  if (!b.paid_status) return null;
  return b.paid_status === 'paid' ? (
    <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300" title={b.paid_amount != null ? `Amazon paid ${fmt(b.paid_amount)}` : 'Found in payment file'} data-testid={`paid-badge-${b.block_id}`}>
      Paid{b.paid_amount != null ? ` ${fmt(b.paid_amount)}` : ''}
    </span>
  ) : (
    <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300" title="Not found in any payment file" data-testid={`paid-badge-${b.block_id}`}>
      Not paid
    </span>
  );
};
